import { clone, remove } from 'lodash'
import { AiOutlineClose, AiOutlinePlus } from 'react-icons/ai'
import { Button, TextInput } from 'Components/Form'
import * as Yup from 'yup'

export const dataDefault = {
    height: '',
    width: '',
    length: '',
    weight: '',
}

export const palletsSchema = Yup.object().shape({
    height: Yup.number().required('The height field is required.'),
    width: Yup.number().required('The width field is required.'),
    length: Yup.number().required('The length field is required.'),
    weight: Yup.number().required('The weight field is required.'),
})

export default function Pallets({ index, datas, data, setFieldValue, touched, errors, status }) {
    const name = `pallets[${index}].`
    return (
        <div className="flex flex-col gap-3">
            <div className={`grid grid-cols-2 gap-3 sm:grid-cols-5`}>
                <TextInput
                    type="number"
                    id={`${name}height`}
                    name={`${name}height`}
                    label="Height (cm)"
                    value={data.height}
                    onChange={e => setFieldValue(`${name}height`, e.target.value)}
                    error={touched?.height && errors?.height}
                />
                <TextInput
                    type="number"
                    id={`${name}width`}
                    name={`${name}width`}
                    label="Width (cm)"
                    value={data.width}
                    onChange={e => setFieldValue(`${name}width`, e.target.value)}
                    error={touched?.width && errors?.width}
                />
                <TextInput
                    type="number"
                    id={`${name}length`}
                    name={`${name}length`}
                    label="Length (cm)"
                    value={data.length}
                    onChange={e => setFieldValue(`${name}length`, e.target.value)}
                    error={touched?.length && errors?.length}
                />
                <TextInput
                    type="number"
                    id={`${name}weight`}
                    name={`${name}weight`}
                    label="Weight (KGs)"
                    value={data.weight}
                    onChange={e => setFieldValue(`${name}weight`, e.target.value)}
                    error={touched?.weight && errors?.weight}
                />
                <div>
                    {[0, 1, 3].includes(status) ? (
                        <div className={`flex items-center gap-3 sm:pt-7 `}>
                            {index + 1 === datas.length ? (
                                <Button
                                    type="button"
                                    className="text-white border-primary bg-primary dark:border-secondary dark:bg-secondary"
                                    onClick={() => {
                                        const saveTask = clone(datas)
                                        saveTask.push(dataDefault)
                                        setFieldValue('pallets', saveTask)
                                    }}
                                >
                                    <AiOutlinePlus size={20} />
                                </Button>
                            ) : null}
                            {datas.length > 1 ? (
                                <Button
                                    type="button"
                                    className="text-white border-danger bg-danger"
                                    onClick={() => {
                                        const saveTask = clone(datas)
                                        remove(saveTask, (n, key) => key === index)
                                        setFieldValue('pallets', saveTask)
                                    }}
                                >
                                    <AiOutlineClose size={20} />
                                </Button>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
